import script from "./IconWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./IconWrapper.vue?vue&type=script&setup=true&lang=js"

import "./IconWrapper.vue?vue&type=style&index=0&id=0ee5f828&lang=scss"

export default script